import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, withPreloading } from '@angular/router';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { tokenInterceptorInterceptor } from './interceptors/token-interceptor.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { BrowserModule } from '@angular/platform-browser';
import { routes } from './app.routes';
import { CustomPreloadingStrategyService } from './services/custom-preloading-strategy.service';
import { CrashMonitorService } from './services/crash-monitor.service';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [BrowserModule, provideRouter(routes, withPreloading(CustomPreloadingStrategyService),), provideAnimationsAsync(), provideHttpClient(withInterceptors([tokenInterceptorInterceptor])),
    { provide: ErrorHandler, useClass: CrashMonitorService },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore())]
};
